import React, { useContext, useEffect, useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { qualityApi } from 'api/quality';
import { UserContext } from 'contexts/UserContext';
import { TabPanel } from 'shared';

import { DirectedReceivablePurchaseOrders } from './directedReceivablePurchaseOrders';

function InboundReceiving({ baseUrl }) {
    const [directedReceivingPhase3Enabled, setDirectedReceivingPhase3Enabled] = useState(false);
    const user = useContext(UserContext);
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    useEffect(() => {
        const getDirectedRecPhase3Enabled = async () => {
            const res = await qualityApi.getDirectedRecPhase3Enabled(user.getFacilityID());
            if (!res.status) {
                return;
            }
            setDirectedReceivingPhase3Enabled(res.data.directedReceivingPhase3Enabled);
        };
        getDirectedRecPhase3Enabled();
    }, []);

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="Receivable Purchase Orders" value="0" />
                <Tab label="Completed Purchase Orders" value="1" />
                {directedReceivingPhase3Enabled && <Tab label="Pending Actions" value="2" />}
                {directedReceivingPhase3Enabled && <Tab label="Issue Line Items" value="3" />}
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <DirectedReceivablePurchaseOrders showReceived={false} />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <DirectedReceivablePurchaseOrders showReceived />
            </TabPanel>
            {directedReceivingPhase3Enabled && (
                <TabPanel selectedTab={selectedTab} index="2">
                    <DirectedReceivablePurchaseOrders showPendingActions />
                </TabPanel>
            )}
            {directedReceivingPhase3Enabled && (
                <TabPanel selectedTab={selectedTab} index="3">
                    <DirectedReceivablePurchaseOrders showPendingIssues />
                </TabPanel>
            )}
        </Paper>
    );
}

export { InboundReceiving };
